import React, { Fragment, useEffect, useRef, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { ProgressBar } from "primereact/progressbar";
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	Col,
	Container,
	Form,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
} from "reactstrap";
import axiosInstance from "../axios";
import Breadcrumb from "../common/breadcrumb";

import SliderDataTabel from "../common/sliderDataTabel";
import { toast } from "react-toastify";

const Slider = () => {
	const [render, setRender] = useState(false);
	const [open, setOpen] = useState(false);
	const [data, setData] = useState([]);
	const initialFormData = Object.freeze({
		title_ar: "",
		title_en: "",
	});
	const [formData, updateFormData] = useState(null);

	const onOpenModal = () => {
		setOpen(true);
	};

	const onCloseModal = () => {
		setOpen(false);
	};

	useEffect(() => {
		axiosInstance.get(`/admin/main-page-slider`).then((res) => {
			setData(res.data);
		});
	}, [render]);

	const [image, setImage] = useState(null);

	const [progressValue, setProgressValue] = useState(0);
	const config = {
		headers: { "Content-Type": "multipart/form-data" },
		onUploadProgress: function (progressEvent) {
			var percentCompleted = Math.round(
				(progressEvent.loaded * 100) / progressEvent.total
			);
			setProgressValue(percentCompleted);
		},
	};

	const handleSubmit = (e) => {
		const formData1 = new FormData();
		if (image) {
			if (formData?.title_ar) {
				formData1.append("title_ar", formData?.title_ar);
			}
			if (formData?.title_en) {
				formData1.append("title_en", formData?.title_en);
			}
			if (formData?.description_ar) {
				formData1.append("description_ar", formData?.description_ar);
			}
			if (formData?.description_en) {
				formData1.append("description_en", formData?.description_en);
			}
			formData1.append("url", image);
			formData1.append("is_deleted", true);
			e.preventDefault();
			axiosInstance
				.post(
					`/admin/main-page-slider`,
					formData1,
					config
					// testFunction
				)
				.then((res) => {
					// setRender(res.data.id);
					updateFormData(null);
					setRender(!render);
					onCloseModal("VaryingMdo");
					toast.success("تم الانشاء بنجاح");
					setProgressValue(0);
				})
				.catch((err) => {
					setProgressValue(0);
					if (err.response.status === 400) {
						toast.warning(`تاكد من البيانات المدخلة`);
					} else {
						toast.error(`${err.response.status} تاكد من البيانات المدخلة`);
					}
				});
		} else {
			toast.warning("يرجى اختيار صورة");
		}
	};

	const handleChange = (e) => {
		updateFormData({
			...formData,
			// Trimming any whitespace
			[e.target.name]: e.target.value,
		});
	};

	const handleChangeImage = (e) => {
		setImage(e.target.files[0]);
		// Trimming any whitespace
	};
	function HandleRender() {
		setRender(!render);
	}

	return (
		<Fragment>
			<Breadcrumb title="الصورة الرئيسية" />
			{/* <!-- Container-fluid starts--> */}
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<CardBody>
								<div className="btn-popup pull-right">
									<Button
										type="button"
										color="primary"
										onClick={onOpenModal}
										data-toggle="modal"
										data-original-title="test"
										data-target="#exampleModal">
										اضافة صورة رئيسية
									</Button>
									<Modal isOpen={open} toggle={onCloseModal}>
										<ModalHeader toggle={onCloseModal}>
											<h5 className="modal-title f-w-600" id="exampleModalLabel2">
												اضافة صورة رئيسية
											</h5>
										</ModalHeader>
										<ModalBody>
											<Form>
												<FormGroup>
													<Label htmlFor="recipient-name" className="col-form-label">
														الاسم عربى :
													</Label>
													<Input
														type="text"
														name="title_ar"
														className="form-control"
														onChange={handleChange}
													/>
												</FormGroup>
												<FormGroup>
													<Label htmlFor="recipient-name" className="col-form-label">
														الاسم انجليزي :
													</Label>
													<Input
														type="text"
														name="title_en"
														className="form-control"
														onChange={handleChange}
													/>
												</FormGroup>
												<FormGroup>
													<Label htmlFor="recipient-name" className="col-form-label">
														الوصف عربى :
													</Label>
													<Input
														type="text"
														name="description_ar"
														className="form-control"
														onChange={handleChange}
													/>
												</FormGroup>
												<FormGroup>
													<Label htmlFor="recipient-name" className="col-form-label">
														الوصف انجليزي :
													</Label>
													<Input
														type="text"
														name="description_en"
														className="form-control"
														onChange={handleChange}
													/>
												</FormGroup>
												<FormGroup>
													<Label htmlFor="message-text" className="col-form-label">
														صورة :<p> مقاس الصورة (px) 1920 * 718 </p>
													</Label>
													<Input
														name="url"
														className="form-control"
														id="validationCustom02"
														type="file"
														onChange={handleChangeImage}
													/>
												</FormGroup>
												<div className="card">
													<ProgressBar color="secondary" value={progressValue}></ProgressBar>
												</div>
											</Form>
										</ModalBody>
										<ModalFooter className="d-flex justify-content-between">
											<Button
												type="button"
												color="secondary"
												onClick={(e) => {
													handleSubmit(e);
												}}>
												حفظ
											</Button>
											<Button
												type="button"
												color="primary"
												onClick={() => onCloseModal("VaryingMdo")}>
												اغلاق
											</Button>
										</ModalFooter>
									</Modal>
								</div>
								<div className="clearfix"></div>
								<div id="basicScenario" className="product-physical">
									<SliderDataTabel
										myData={data}
										multiSelectOption={false}
										pageSize={10}
										// pagination={true}
										class="-striped -highlight"
										HandleRender={HandleRender}
									/>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
			{/* <!-- Container-fluid Ends--> */}
		</Fragment>
	);
};

export default Slider;
